import { render, staticRenderFns } from "./spotter_settings.vue?vue&type=template&id=9df7e148&scoped=true&"
import script from "./spotter_settings.vue?vue&type=script&lang=js&"
export * from "./spotter_settings.vue?vue&type=script&lang=js&"
import style0 from "./spotter_settings.vue?vue&type=style&index=0&id=9df7e148&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df7e148",
  null
  
)

export default component.exports